// Material Symbols "local_shipping" glyph (24x24 viewBox). Shared between
// the map's vehicle marker and the layers drawer's Vehicle Status legend,
// so the legend's swatches actually look like what's on the map instead of
// plain color dots.
export const VEHICLE_ICON_PATH = 'M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zM18 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z';

// Teardrop map-pin outline (24x24 viewBox) - the stock Material "place"
// glyph punches a hole through the middle of the head, which is exactly
// where the S/D/number label sits, making white text on it invisible; this
// is that same outline with the hole subpath dropped so the head is solid.
// Shared between the map's S/D/waypoint pins and the layers drawer's
// Waypoints legend, so the legend's swatches match what's on the map.
export const WAY_POINT_ICON_PATH = 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z';
